import React, { useEffect, useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface CarouselProps {
  images: {
    src: string;
    alt: string;
  }[];
  autoplay?: boolean;
  interval?: number;
}
export const Carousel = ({
  images,
  autoplay = true,
  interval = 5000
}: CarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToNext = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
  };
  const goToPrev = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + images.length) % images.length);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  useEffect(() => {
    if (!autoplay) return;
    const timer = setInterval(goToNext, interval);
    return () => clearInterval(timer);
  }, [autoplay, interval]);
  return <div className="relative rounded-lg overflow-hidden shadow-lg" data-id="element-316">
      <div className="overflow-hidden relative aspect-[16/9]" data-id="element-317">
        {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-500 ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-318">
            <img src={image.src} alt={image.alt} className="w-full h-full object-cover" loading={index === 0 ? 'eager' : 'lazy'} style={{
          maxWidth: '100%',
          height: 'auto'
        }} data-id="element-319" />
          </div>)}
        <button onClick={goToPrev} className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 bg-white/80 border border-gray-200 hover:bg-white hover:border-primary rounded-full shadow-md transition-colors" data-id="element-320">
          <ChevronLeft size={24} className="text-secondary hover:text-primary" data-id="element-321" />
        </button>
        <button onClick={goToNext} className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 bg-white/80 border border-gray-200 hover:bg-white hover:border-primary rounded-full shadow-md transition-colors" data-id="element-322">
          <ChevronRight size={24} className="text-secondary hover:text-primary" data-id="element-323" />
        </button>
      </div>
      <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2" data-id="element-324">
        {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-3 h-3 rounded-full border border-white ${index === currentIndex ? 'bg-primary border-primary' : 'bg-white/70'}`} data-id="element-325" />)}
      </div>
    </div>;
};